import { useState } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router';

import { ImportLineupModal } from '#src/components/importLineup/ImportLineupModal/index.tsx';

export const ImportLineup = () => {
  const location = useLocation();

  const [searchParams] = useSearchParams();

  const paramsId = searchParams.get('batchId');
  const paramsProvider = searchParams.get('provider');

  const [id, setId] = useState(paramsId);
  const [provider] = useState(paramsProvider || 'SorareData');

  if (paramsId || paramsProvider) {
    searchParams.delete('batchId');
    searchParams.delete('provider');
    const cleanedParams = searchParams.toString();
    return (
      <Navigate
        to={{ pathname: location.pathname, search: cleanedParams }}
        replace
      />
    );
  }

  return (
    <ImportLineupModal
      id={id}
      provider={provider}
      onComplete={() => setId(null)}
    />
  );
};
